import { useIntl } from 'react-intl'
import { FieldsConfiguration } from '@molecules/Field/Field.types'
import uniqueId from 'lodash/uniqueId'

const getStoreLocatorFields = (onChange, onBlur?): FieldsConfiguration => {
  const { formatMessage } = useIntl()
  return {
    searchInput: {
      id: uniqueId('searchInput'),
      name: 'searchInput',
      type: 'text',
      placeholder: formatMessage({
        defaultMessage: 'Postcode or city',
        id: 'msp.storeLocator.placeholder'
      }),
      onChange: (e: any) => onChange && onChange(e),
      onBlur: () => onBlur && onBlur
    }
  }
}

export default getStoreLocatorFields
